// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"a3f53ef8","453":"348f4895"}[chunkId] + ".chunk.js";
};